const wishes = {
    train:0,
    horse:1,
    star:2,
    candy:3,
    chest:4
}
const ribbons = {
    blue:0,
    green:1,
    purple:2,
    red:3,
    yellow:4
}

const papers={
    xmas:0,
    red:1,
    green:2,
    yellow:3,
    blue:4,
}


WL.registerComponent('list-controller', {
    gift1: {type: WL.Type.Object},
    gift2: {type: WL.Type.Object},
    paper1: {type: WL.Type.Object},
    paper2: {type: WL.Type.Object},
    ribbon1: {type: WL.Type.Object},
    ribbon2: {type: WL.Type.Object},    

    ribbonBlue: {type: WL.Type.Material},
    ribbonGreen: {type: WL.Type.Material},
    ribbonPurple: {type: WL.Type.Material},
    ribbonRed: {type: WL.Type.Material},
    ribbonYellow: {type: WL.Type.Material},

    paperXmas: {type: WL.Type.Material},
    paperRed: {type: WL.Type.Material},
    paperGreen: {type: WL.Type.Material},
    paperYellow: {type: WL.Type.Material},
    paperBlue: {type: WL.Type.Material},

    wishTrain: {type: WL.Type.Material},
    wishHorse: {type: WL.Type.Material},
    wishCandy: {type: WL.Type.Material},
    wishStar: {type: WL.Type.Material},
    wishChest: {type: WL.Type.Material},
}, {
    init: function() {                 
        this.listMesh = this.object.getComponent('mesh');

         this.meshes1 = {
                gift: this.gift1.getComponent('mesh'),
                paper: this.paper1.getComponent('mesh'),
                ribbon: this.ribbon1.getComponent('mesh'),
         }
         this.meshes2 = {
            gift: this.gift2.getComponent('mesh'),
            paper: this.paper2.getComponent('mesh'),
            ribbon: this.ribbon2.getComponent('mesh'),
        }        
        this.numberOfGifts = 0;       
        this.updateVisibility();
    },
    updateVisibility() {
        this.meshes1.gift.active = false;
        this.meshes1.paper.active = false;
        this.meshes1.ribbon.active = false;
        this.meshes2.gift.active = false;
        this.meshes2.paper.active = false;
        this.meshes2.ribbon.active = false;
        this.listMesh.active = false;
        if(this.numberOfGifts>0){
            this.listMesh.active = true;
            this.meshes1.gift.active = true;
            this.meshes1.paper.active = true;
            this.meshes1.ribbon.active = true;
        }
        if(this.numberOfGifts>1){
            this.meshes2.gift.active = true;
            this.meshes2.paper.active = true;
            this.meshes2.ribbon.active = true;
        }        
    },    
    setMeshes(meshes, gift, paper, ribbon){
        switch(gift){
            case wishes.train:
                meshes.gift.material = this.wishTrain;
                break;
            case wishes.horse:
                meshes.gift.material = this.wishHorse;
                break;
            case wishes.candy:
                meshes.gift.material = this.wishCandy;
                break;
            case wishes.star:
                meshes.gift.material = this.wishStar;
                break;
            case wishes.chest:
                meshes.gift.material = this.wishChest;
                break;
        }

        switch(paper){
            case papers.xmas:
                meshes.paper.material = this.paperXmas;
                break;
            case papers.red:
                meshes.paper.material = this.paperRed;
                break;
            case papers.green:
                meshes.paper.material = this.paperGreen;
                break;
            case papers.yellow:
                meshes.paper.material = this.paperYellow;
                break;
            case papers.blue:
                meshes.paper.material = this.paperBlue;
                break;
        }

        switch(ribbon){
            case ribbons.blue:
                meshes.ribbon.material = this.ribbonBlue;
                break;
            case ribbons.green:
                meshes.ribbon.material = this.ribbonGreen;
                break;
            case ribbons.purple:
                meshes.ribbon.material = this.ribbonPurple;
                break;
            case ribbons.red:
                meshes.ribbon.material = this.ribbonRed;
                break;
            case ribbons.yellow:
                meshes.ribbon.material = this.ribbonYellow;
                break;
        }

    },
    /**
     * A gift contains the constants for {gift, paper, ribbon}
     * @param {Gift} gift1 
     * @param {Gift} gift2 
     */
    setGifts(gift1, gift2){
        this.numberOfGifts = 0;
        if(!!gift1)
        {
            this.setMeshes(this.meshes1, gift1.gift, gift1.paper, gift1.ribbon);
            this.numberOfGifts++; 
        }
        if(!!gift2)
        {
            this.setMeshes(this.meshes2, gift2.gift, gift2.paper, gift2.ribbon);
            this.numberOfGifts++; 
        }        
        this.updateVisibility();
    },
    start: function() {
    
    },
    update: function(dt) {
    
    },
});
